import DefaultAvatar1 from '@assets/icons/defaultAvatars/DefaultAvatar1.webp'
import DefaultAvatar2 from '@assets/icons/defaultAvatars/DefaultAvatar2.webp'
import DefaultAvatar3 from '@assets/icons/defaultAvatars/DefaultAvatar3.webp'
import DefaultAvatar4 from '@assets/icons/defaultAvatars/DefaultAvatar4.webp'
import DefaultAvatar5 from '@assets/icons/defaultAvatars/DefaultAvatar5.webp'
import DefaultAvatar6 from '@assets/icons/defaultAvatars/DefaultAvatar6.webp'
import DefaultAvatar7 from '@assets/icons/defaultAvatars/DefaultAvatar7.webp'
import DefaultAvatar8 from '@assets/icons/defaultAvatars/DefaultAvatar8.webp'
import DefaultAvatar9 from '@assets/icons/defaultAvatars/DefaultAvatar9.webp'
import DefaultAvatar10 from '@assets/icons/defaultAvatars/DefaultAvatar10.webp'

/**
 * The set of default avatar images shown when a member has neither a
 * merge-synced nor a user-uploaded avatar. Order is significant: it defines
 * the mapping used by {@link getDefaultAvatar}, so images must only ever be
 * appended (never reordered or removed) to keep each member's avatar stable.
 */
export const defaultAvatars = [
  DefaultAvatar1,
  DefaultAvatar2,
  DefaultAvatar3,
  DefaultAvatar4,
  DefaultAvatar5,
  DefaultAvatar6,
  DefaultAvatar7,
  DefaultAvatar8,
  DefaultAvatar9,
  DefaultAvatar10,
]

/**
 * Deterministic 32-bit string hash (djb2 * 31 variant). Stable across
 * sessions and browsers so a given member id always maps to the same bucket.
 */
const hashId = (id: string): number => {
  let hash = 0
  for (let i = 0; i < id.length; i++) {
    hash = (hash * 31 + id.charCodeAt(i)) | 0
  }
  return Math.abs(hash)
}

/**
 * Picks one of the {@link defaultAvatars} deterministically from a member id
 * (e.g. `tenantMemberId`). The same id always resolves to the same image, so
 * a member's default avatar is consistent everywhere it renders.
 *
 * Returns `undefined` when no id is available, letting callers fall back to
 * initials.
 */
export const getDefaultAvatar = (tenantMemberId?: string | null): string | undefined => {
  if (!tenantMemberId) return undefined
  return defaultAvatars[hashId(tenantMemberId) % defaultAvatars.length]
}
